export default __webpack_public_path__ + "static/media/marker.eb8d08c8.svg";